import React from 'react'
import { Grid } from '@material-ui/core'
import PropTypes from 'prop-types'
import CompanyLogo from '../../../app/components/companyLogo'
import { LoginTitle, StyledButton, StyledExternalLink, StyledParagraph, StyledTextField } from '../../../theme/Global'
import { CircularProgressInnerButton } from './styles'

const ForgotPasswordRenderer = ({
  email,
  forgotPasswordStatus,
  onChangeEmail,
  onLogIn,
  status,
  setStatus,
  submit,
  cognitoForgotPasswordSubmit
}) => (
  // eslint-disable-next-line react/jsx-filename-extension
  <Grid container spacing={24} justify="center">
    <Grid item xs={12}>
      <CompanyLogo size="login" color />
    </Grid>
    <Grid item xs={12}>
      <LoginTitle>Reset Password</LoginTitle>
    </Grid>
    <Grid item xs={12}>
      {status === 'idle' ? (
        <StyledParagraph>
              Enter your email below and we'll send you a confirmation code.
        </StyledParagraph>
      ) : null}
      {status === 'noEmail' ? (
        <StyledParagraph>Please enter your email below.</StyledParagraph>
      ) : null}
      {status === 'attempt' && forgotPasswordStatus === 'failure' ? (
        <StyledParagraph>
              There was a problem trying to send your forgot password email. Please try again.
        </StyledParagraph>
      ) : null}
      {status === 'attempt' && forgotPasswordStatus === 'success' ? (
        <StyledParagraph>
              We sent an email with instructions on how to reset your password to
          {' '}
          {email}
        </StyledParagraph>
      ) : null}
      {status === 'attempt' && forgotPasswordStatus === 'attempting' ? (
        <StyledParagraph>Please wait while we send your instructions.</StyledParagraph>
      ) : null}
      {status === 'attempting' ? (
        <StyledParagraph>Please wait while we send your instructions.</StyledParagraph>
      ) : null}
      {status === 'emailNotFound' ? (
        <StyledParagraph>
              Cannot find the email provided.
        </StyledParagraph>
      ) : null}
      {status === 'limitExceeded' ? (
        <StyledParagraph>
              You have exceeded the limit of forgot password requests. Please try again later.
        </StyledParagraph>
      ) : null}
    </Grid>
    <Grid item xs={12}>
      <StyledTextField
        fullWidth
        label="E-mail Address"
        onChange={onChangeEmail}
        name="email"
        type="text"
      />
    </Grid>
    <Grid item xs={12}>
      <Grid container spacing={24} direction="row" justify="flex-start" alignItems="center">
        <Grid item>
          <StyledButton
            disabled={forgotPasswordStatus === 'attempting' || status === 'attempting'}
            onClick={() => {
              if (cognitoForgotPasswordSubmit) {
                cognitoForgotPasswordSubmit(email, setStatus)
              } else {
                submit()
              }
            }}
          >
            {forgotPasswordStatus === 'attempting' || status === 'attempting' ? <CircularProgressInnerButton size={16} /> : null}
            Send E-Mail
          </StyledButton>
        </Grid>
        <Grid item>
          <StyledExternalLink onClick={onLogIn} onKeyPress={onLogIn} tabIndex={0}>
            Log In Now
          </StyledExternalLink>
        </Grid>
      </Grid>
    </Grid>
  </Grid>
)

ForgotPasswordRenderer.propTypes = {
  email: PropTypes.string.isRequired,
  onChangeEmail: PropTypes.func.isRequired,
  onLogIn: PropTypes.func.isRequired,
  status: PropTypes.string.isRequired,
  submit: PropTypes.func.isRequired
}

export default ForgotPasswordRenderer
